import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, Field } from 'redux-form'
import { Button, Row, Col } from 'react-bootstrap'
import * as actions from '../../../actions'
import { FORM_PEDIDO_EGRESO } from '../../../../../config/forms'
import { renderTextField } from '../../../../Forms/fieldRenderers'
import {
  required,
  getNumericValidator
} from '../../../../Forms/fieldValidators'
import {
  CerealDropdown
} from '../../../../Forms/SharedComponents/containers'

const numeric0to999 = getNumericValidator(0, 999)

class Abandono0 extends Component {
  render () {
    const {
      handleSubmit,
      invalid
    } = this.props

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={3} />
            <Col md={4}>
              <CerealDropdown />
            </Col>
            <Col md={2}>
              <Field
                name='cantidad'
                label='Cantidad'
                type='number'
                component={renderTextField}
                validate={[required, numeric0to999]}
                placeholder='20'
              />
            </Col>
            <Col md={3} />
          </Row>
          <br />
          <Button
            type='submit'
            disabled={invalid}
            size='lg'
          >Aceptar</Button>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_PEDIDO_EGRESO)(state)
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PEDIDO_EGRESO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(Abandono0))
